import React, { useState, useEffect } from 'react';
import { colors, fontWeights } from '../../theme/tokens';

// School logo uploaded in the admin panel (`schoolLogo`); falls back to the
// school's initial when no logo is set or the image fails to load.
const SchoolLogo = ({ src, name, size = 40, radius, variant = 'soft', style }) => {
  const [failed, setFailed] = useState(false);
  useEffect(() => { setFailed(false); }, [src]);

  const showImage = Boolean(src) && !failed;
  const solid = variant === 'solid';
  const initial = (String(name || '?').trim().charAt(0) || '?').toUpperCase();

  return (
    <span
      aria-hidden={showImage ? undefined : 'true'}
      style={{
        width: size,
        height: size,
        borderRadius: radius != null ? radius : Math.round(size * 0.28),
        background: showImage ? colors.white : solid ? colors.navy : colors.softBlue,
        color: solid ? colors.white : colors.navy,
        border: showImage ? `1px solid ${colors.border}` : 'none',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: Math.round(size * 0.42),
        fontWeight: fontWeights.bold,
        lineHeight: 1,
        flexShrink: 0,
        overflow: 'hidden',
        boxSizing: 'border-box',
        ...style,
      }}
    >
      {showImage ? (
        <img loading="lazy" decoding="async"
          src={src}
          alt={name ? `${name} logo` : 'School logo'}
          onError={() => setFailed(true)}
          style={{ width: '100%', height: '100%', objectFit: 'contain', display: 'block' }}
        />
      ) : (
        initial
      )}
    </span>
  );
};

export default SchoolLogo;
